import { getUserNotifications } from 'api/notifications.api';
import { $list, $view } from 'signals/global.signals';
import displayError from 'utils/displayError';

export const fetchAndSetInvestorNotifications = async () => {
  $view.update({ isLoading: true });

  try {
    const { data } = await getUserNotifications();
    $list.update({ data });
  } catch (e) {
    displayError({
      message: 'Failed to load notifications. Please refresh the page.',
      title: 'Loading Error',
    });
  } finally {
    $view.update({ isLoading: false });
  }
};
